// extracted by mini-css-extract-plugin
export default {"newsList":"index-module_newsList_Uk3M7","news":"index-module_news_-ukyM","title":"index-module_title_tdArX"};